const uz = {
    meta: {
        title: "Google Business profil sozlash: xaritada topilish | Innobek",
        description:
            "Google Business profilini sozlash: kategoriya, NAP birxilligi, sharhlar, foto va o'lchash. Xaritadagi arizani qanday hisoblash va narx bilan solishtirish kerak.",
        keywords: [
            "Google Business profil sozlash",
            "xaritada biznesni qo'shish",
            "mahalliy SEO Toshkent",
            "Google xaritada yuqoriga chiqish",
            "mijoz sharhlari bilan ishlash",
            "yaqin atrofda qidiruv",
        ],
    },
    h1: "Xaridor «yaqin atrofda» deb qidirganda sizni topadimi?",
    lead:
        "Offlayn nuqtaga ega biznes uchun xarita natijasi ko'pincha saytdan oldin keladi. Profil esa bepul — ish faqat aniqlik va muntazamlikda. Quyida nima sozlanishi kerakligini, natijani qanday o'lchashni va bu kanal qachon sizga mos emasligini ko'rib chiqamiz.",
    category: "SEO va o'sish",
    readingTime: "9 daqiqa",

    body: [
        {
            type: "p",
            text:
                "Do'kon, klinika, servis yoki restoran egasi uchun eng arzon mijoz oqimi xaritadan keladi. Lekin ko'p kompaniyada profil yo umuman ochilmagan, yo bir marta to'ldirilib tashlab qo'yilgan. Natijada mijoz ikki yuz metr naridagi raqobatchiga ketadi.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "«Yaqin atrofda» so'rovi qanday ishlaydi?" },
        {
            type: "p",
            text:
                "Foydalanuvchi telefonda «yaqin atrofda stomatologiya» yoki shunchaki «shinalar almashtirish» deb yozganda, Google avval xarita blokini ko'rsatadi — odatda uchta biznes kartochkasi, reyting, ish vaqti va marshrut tugmasi bilan. Oddiy sayt natijalari shu blokdan pastda turadi.",
        },
        {
            type: "p",
            text:
                "Bu bloklarga sayt emas, Google Business profili chiqadi. Profil — bu Google'dagi biznes kartochkangiz: nom, manzil, telefon, kategoriya, ish vaqti, fotolar, sharhlar va postlar. U bepul va uni o'zingiz boshqarasiz.",
        },
        {
            type: "p",
            text:
                "Muhim nuqta: bu so'rovlarning niyati juda issiq. Odam ma'lumot izlamayapti — u hozir borishga tayyor. Shuning uchun xaritadagi ariza tannarxi odatda boshqa kanallarnikidan past chiqadi.",
        },

        { type: "h2", text: "Xarita natijasiga nima ta'sir qiladi?" },
        {
            type: "p",
            text:
                "Google mahalliy natijani uchta guruh signal asosida tuzadi. Bu guruhlarni bilish muhim, chunki ularning ikkitasiga siz to'liq ta'sir qila olasiz, bittasiga esa deyarli yo'q.",
        },
        {
            type: "list",
            items: [
                "Moslik — profilingiz so'rovga qanchalik to'g'ri keladi. Bu yerda asosiy vosita: to'g'ri asosiy kategoriya, qo'shimcha kategoriyalar va xizmatlar ro'yxati. Bu sizning nazoratingizda.",
                "Masofa — foydalanuvchi qayerda turibdi. Buni o'zgartirib bo'lmaydi, lekin xizmat hududini to'g'ri belgilash orqali chegarani kengaytirish mumkin.",
                "Nufuz — kompaniya internetda qanchalik ko'p va izchil eslatiladi: sharhlar soni va sifati, saytdagi signallar, boshqa katalog va ma'lumotnomalardagi yozuvlar. Bu eng sekin, lekin eng barqaror qism.",
            ],
        },
        { type: "image", image: 1 },
        {
            type: "p",
            text:
                "Amaliyotda eng katta o'sish birinchi va uchinchi guruhdan chiqadi. Kategoriya noto'g'ri tanlangan profil hech qanday sharh bilan ham kerakli so'rovga chiqmaydi — Google shunchaki uni boshqa so'rovga tegishli deb hisoblaydi.",
        },

        { type: "h2", text: "Profilda eng ko'p uchraydigan yetti xato" },
        {
            type: "p",
            text:
                "Quyidagi ro'yxatni ochib, o'z profilingizni qatorma-qator tekshiring. Aksariyat kompaniyada kamida uchtasi topiladi va ularning hammasi bepul tuzatiladi.",
        },
        {
            type: "ol",
            items: [
                "Asosiy kategoriya noaniq tanlangan. «Do'kon» o'rniga «Avtoehtiyot qismlar do'koni» kabi aniq kategoriya tanlansin — moslik shundan boshlanadi.",
                "Xizmatlar ro'yxati bo'sh. Har bir xizmatni alohida band qilib yozing: mijoz aynan shu so'zlar bilan qidiradi.",
                "Ish vaqti eskirgan yoki bayram kunlari ko'rsatilmagan. Yopiq eshik oldiga kelgan mijoz sharh qoldiradi va u salbiy bo'ladi.",
                "Fotolar yo'q yoki bitta logotip turibdi. Tashqi ko'rinish, ichki muhit, jamoa va ish jarayoni fotolari kerak — mijoz kirishdan oldin joyni tanishi shart.",
                "Telefon raqami sayt va profilda har xil. Bu eng oddiy, lekin eng ko'p zarar keltiradigan nomuvofiqlik.",
                "Sahifa tili bitta. O'zbekiston bozorida tavsif va xizmat nomlarini ikkala tilda berish mantiqiy — buni ikki tilli SEO bo'yicha alohida maqolada batafsil yozganmiz.",
                "Saytga havola bosh sahifaga qo'yilgan. Agar profil bitta filialga tegishli bo'lsa, havola o'sha filial sahifasiga UTM belgisi bilan ketsin.",
            ],
        },

        { type: "h2", text: "NAP birxilligi nima va nega u muhim?" },
        {
            type: "p",
            text:
                "NAP — bu nom (Name), manzil (Address) va telefon (Phone). Birxillik degani: bu uchtasi saytingizda, Google profilida, ijtimoiy tarmoq sahifalarida va tashqi kataloglarda so'zma-so'z bir xil yozilgan bo'lishi kerak.",
        },
        {
            type: "p",
            text:
                "Nomuvofiqlik ko'pincha jimgina paydo bo'ladi. Ofis ko'chdi — saytda yangilandi, profilda qoldi. Yangi telefon ulandi — profilda yangilandi, katalogda eski qoldi. Google uchun bu ikki xil biznes bo'lib ko'rinishi mumkin va nufuz signali ikkiga bo'linadi.",
        },
        { type: "image", image: 2 },
        {
            type: "p",
            text:
                "Tekshirish usuli oddiy: kompaniya nomini va telefon raqamini qidiruvga qo'yib, chiqqan barcha yozuvlarni ro'yxatga oling. Keyin har birini bitta etalon yozuv bilan solishtiring. Bu bir martalik ish, keyin esa har o'zgarishda shu ro'yxat bo'yicha yangilanadi.",
        },

        { type: "h2", text: "Sharhlar bilan qanday ishlash kerak?" },
        {
            type: "p",
            text:
                "Sharh — mahalliy natijadagi eng kuchli va eng arzon vosita. Lekin uni sotib olmang: soxta sharhlar aniqlanadi va profil cheklovga tushishi mumkin. To'g'ri yo'l — muntazam va tabiiy oqim qurish.",
        },
        {
            type: "list",
            items: [
                "Sharh so'rashni jarayonga kiriting: xizmat tugagach SMS yoki Telegram orqali to'g'ridan-to'g'ri havola yuboring. Havola qancha qisqa bo'lsa, konversiya shuncha yuqori.",
                "Har bir sharhga javob bering — ijobiysiga ham. Javobsiz profil tashlab qo'yilgandek ko'rinadi.",
                "Salbiy sharhga 24 soat ichida javob bering, bahslashmang va yechimni ommaga ko'rsating. Bu sharhni o'qiyotgan keyingi mijoz uchun yoziladi, muallif uchun emas.",
                "Javobda xizmat nomini tabiiy ishlating — bu profilning so'rovga mosligiga ham foyda beradi.",
                "Sharhlar oqimini bir tekis taqsimlang. Bir haftada yigirmata sharh kelib, keyin olti oy jimlik — bu tabiiy ko'rinmaydi.",
            ],
        },

        { type: "h2", text: "Natijani qanday o'lchaysiz?" },
        {
            type: "p",
            text:
                "Xarita kanalining asosiy muammosi — uni ko'pincha umuman o'lchashmaydi. «Odam ko'paydiganga o'xshaydi» degan gap byudjet qarorini qo'llab-quvvatlamaydi. Quyidagi to'rtta raqam yetarli.",
        },
        {
            type: "ol",
            items: [
                "Profildagi ko'rsatkichlar: qidiruvdan ko'rinishlar, saytga bosishlar, qo'ng'iroqlar va marshrut so'rovlari soni. Bu ma'lumot profilning o'zida bepul turadi.",
                "Saytga havolaga UTM belgisi qo'ying — shunda Analytics'da xaritadan kelgan tashrif alohida ko'rinadi.",
                "Qo'ng'iroqlar uchun alohida raqam yoki CRM'da «manba» maydonini ishlating. Menejer har qo'ng'iroqda «qayerdan topdingiz?» deb so'rasa ham bo'ladi.",
                "Oyning oxirida arizalar sonini xizmat narxiga bo'ling — bu kanalning ariza tannarxi. Endi uni Google Ads va SEO bilan bitta jadvalda solishtirish mumkin.",
            ],
        },
        {
            type: "p",
            text:
                "Ariza tannarxini kanallar bo'yicha qanday hisoblash kerakligini alohida maqolada formulasi bilan yozganmiz. Xarita odatda shu jadvalda eng past tannarxni beradi — lekin hajmi cheklangan, chunki u faqat yaqin atrofdagi auditoriyaga ishlaydi.",
        },

        { type: "h2", text: "Qancha turadi va qachon o'zini oqlaydi?" },
        {
            type: "p",
            text:
                "Profilning o'zi Google'da bepul. Siz faqat ish uchun to'laysiz — sozlash, kontent va muntazam yuritish uchun. Quyida Innobek narxlari va nima kirishi ko'rsatilgan.",
        },
        {
            type: "table",
            head: ["Paket", "Narxi", "Nima kiradi", "Kimga mos"],
            rows: [
                [
                    "Bir martalik sozlash",
                    "2 500 000 so'm",
                    "Profil ochish yoki tiklash, kategoriya va xizmatlar, NAP tekshiruvi, foto va tavsif",
                    "Bitta nuqta, profil hali yo'q yoki tashlab qo'yilgan",
                ],
                [
                    "Oylik yuritish",
                    "2 500 000 so'mdan",
                    "Postlar, foto yangilash, sharhlarga javob, ko'rsatkich hisoboti",
                    "Mijoz oqimi doimiy kerak bo'lgan nuqta",
                ],
                [
                    "Filial tarmog'i",
                    "6 000 000 so'mdan",
                    "Uchtagacha filial, yagona NAB standarti, umumiy hisobot",
                    "Bir nechta manzilda ishlaydigan tarmoq",
                ],
                [
                    "Qo'shimcha filial",
                    "Oyiga 1 500 000 so'm",
                    "Har bir keyingi filial uchun profil va yuritish",
                    "Kengayayotgan tarmoq",
                ],
            ],
        },
        {
            type: "p",
            text:
                "Qaytim hisobini o'z raqamlaringiz bilan qiling. Faraz qilaylik, sozlashdan keyin profil oyiga 30 ta qo'ng'iroq va 40 ta marshrut so'rovi beradi. Ulardan 15 tasi haqiqiy mijozga aylanadi, o'rtacha chek 400 000 so'm, marja 40% — bu oyiga 2 400 000 so'm sof foyda.",
        },
        {
            type: "p",
            text:
                "Shu holatda bir martalik sozlash birinchi oyning o'zidayoq qoplanadi, oylik yuritish esa xarajat sifatida qoladi va o'sishni ushlab turadi. Agar sizning o'rtacha chekingiz 50 000 so'm bo'lsa, hisob butunlay boshqacha chiqadi — sizga hajm kerak, ya'ni xaritadan tashqari kanallar ham.",
        },
        { type: "image", image: 3 },

        { type: "h2", text: "Hech narsa qilmaslikning narxi" },
        {
            type: "p",
            text:
                "Profilsiz qolgan biznes nafaqat trafik yo'qotadi, balki nazoratni ham yo'qotadi. Google kartochkani ko'pincha foydalanuvchi ma'lumotlari asosida o'zi yaratadi: manzil taxminiy, ish vaqti noto'g'ri, telefon eski bo'lishi mumkin.",
        },
        {
            type: "p",
            text:
                "Bunday kartochkaga tushgan salbiy sharhga hech kim javob bermaydi. Mijoz esa yopiq eshik va javobsiz sharhni ko'radi. Ya'ni siz yo'q bo'lgan kanaldan zarar ko'rasiz.",
        },
        {
            type: "callout",
            text:
                "Minimal qadam: profilni egallab oling va uchta narsani to'g'rilang — kategoriya, ish vaqti va telefon. Bu bepul, bir soat vaqt oladi va ko'pincha darhol qo'ng'iroq beradi.",
        },

        { type: "h2", text: "Bu kanal qachon sizga mos emas?" },
        {
            type: "p",
            text:
                "Google Business hamma biznesga baravar foyda bermaydi. Quyidagi holatlarda byudjetni boshqa yerga yo'naltiring.",
        },
        {
            type: "list",
            items: [
                "Mijozlaringiz butun mamlakat bo'ylab va joylashuv ahamiyatsiz. Onlayn xizmat yoki umumiy yetkazib berish modelida xarita deyarli ishlamaydi.",
                "Sotuvingiz tender yoki uzoq B2B muzokara orqali ketadi. Bu yerda qaror xaritadan boshlanmaydi.",
                "Sizda jismoniy manzil yo'q va xizmat hududi ham aniq emas. Google bunday profilni tasdiqlamasligi mumkin.",
                "Nuqtangiz allaqachon quvvatiga to'lgan. Yangi ariza oqimini qabul qila olmasangiz, avval jarayonni kengaytiring.",
                "Sharhlar bilan ishlashga odam ajratmaysiz. Javobsiz salbiy sharhlar profilni foydadan zararga aylantiradi.",
            ],
        },
        {
            type: "quote",
            text:
                "Xarita — bepul kanal emas, arzon kanal. Undagi asosiy xarajat pul emas, muntazamlik.",
        },
    ],

    faq: [
        {
            q: "Google Business profili haqiqatan bepulmi?",
            a: "Ha, profilni ochish, to'ldirish va yuritish uchun Google hech qanday to'lov olmaydi. Pul faqat ish uchun ketadi: kategoriya va xizmatlarni to'g'ri tuzish, foto tayyorlash, postlar yozish va sharhlar bilan muntazam ishlash. Innobek'da bir martalik sozlash 2 500 000 so'm, oylik yuritish esa 2 500 000 so'mdan boshlanadi.",
        },
        {
            q: "Profilni tasdiqlash qancha vaqt oladi?",
            a: "Tasdiqlash usuli biznes turiga qarab farq qiladi: video orqali, pochta orqali kod bilan yoki qo'ng'iroq bilan bo'lishi mumkin. Amaliyotda bu bir necha kundan bir necha haftagacha cho'ziladi va ba'zan takroriy urinish talab qilinadi. Shuning uchun tasdiqlashni marketing kampaniyasi boshlanishidan oldinroq boshlash kerak.",
        },
        {
            q: "Xaritadagi birinchi o'ringa kafolat berish mumkinmi?",
            a: "Yo'q va buni kafolat beradigan gapga ishonmang. Mahalliy natija foydalanuvchining joylashuviga ham bog'liq: bitta profil qo'shni ko'chada birinchi, ikki kilometr naridan esa uchinchi yoki umuman ro'yxatdan tashqarida bo'lib ko'rinishi mumkin. Shuning uchun maqsadni pozitsiyada emas, o'lchanadigan ko'rsatkichlarda qo'ying: ko'rinishlar, qo'ng'iroqlar va marshrut so'rovlari sonining oydan oyga o'sishi.",
        },
        {
            q: "Sharhlarni sotib olsa bo'ladimi?",
            a: "Bu eng qimmatga tushadigan qisqa yo'l. Soxta sharhlar aniqlanadi, ular o'chiriladi va profil cheklovga tushishi mumkin — ba'zan butunlay o'chiriladi. Ancha xavfsiz va samaraliroq yo'l: xizmat tugagach mijozga to'g'ridan-to'g'ri havola yuborish. Muntazam so'ralgan haqiqiy sharh oqimi har qanday sotib olingan reytingdan barqarorroq ishlaydi.",
        },
        {
            q: "Bitta biznes uchun nechta profil bo'lishi kerak?",
            a: "Qoida oddiy: har bir jismoniy manzil uchun bitta profil. Ikkita profil bitta manzilga tushsa, ular dublikat deb belgilanadi va signallar bo'linadi. Filiallar uchun alohida profil ochiladi, lekin nom, telefon va kategoriya standarti yagona bo'lishi kerak. Innobek'da tarmoq paketi 6 000 000 so'mdan boshlanadi.",
        },
        {
            q: "Sayt bo'lmasa, faqat profil bilan ishlasa bo'ladimi?",
            a: "Boshlang'ich bosqichda bo'ladi va bu ko'pincha to'g'ri qaror. Lekin profil ijaraga olingan maydon: qoidalar o'zgaradi, kartochka cheklanishi mumkin va mijoz bazasi sizda qolmaydi. Sayt esa nufuz signallarini kuchaytiradi va xaritadagi pozitsiyaga ham ijobiy ta'sir qiladi. Eng barqaror model — ikkalasi birga.",
        },
    ],

    cta: {
        h: "Profilingizni bepul tekshirib beramiz",
        p:
            "Kategoriya, NAP birxilligi, foto va sharhlar holatini ko'rib chiqamiz hamda qaysi tuzatish eng tez natija berishini aytamiz. Xarita sizning modelingizga mos kelmasa, buni ham ochiq aytamiz.",
        button: "Profilni tekshirtirish",
    },

    images: [
        {
            src: "/assets/img/blog/gbp-yaqin-atrofda.webp",
            alt: "Telefon ekranida xarita qidiruvi natijalari va marshrut tugmalari ko'rsatilgan",
            caption: "«Yaqin atrofda» so'rovi shunday ko'rinadi — sayt natijalari bu blokdan pastda",
            prompt:
                "Phone held in hand showing a map search results list with three local business cards, star ratings and route buttons, blurred city street in the background; realistic mobile photography style, neutral generic map UI, no real brand marks, no readable text, 16:9",
        },
        {
            src: "/assets/img/blog/gbp-omillar.webp",
            alt: "Mahalliy qidiruv natijasiga ta'sir qiluvchi uchta omil ko'rsatilgan sxema",
            caption: "Uch omildan ikkitasi to'liq sizning nazoratingizda",
            prompt:
                "Local ranking factors diagram: three weighted pillars labelled by icon only — relevance (category and services), distance (service area pin), prominence (reviews, mentions, site signals) — feeding into a map pack result card; clean flat infographic, blue and green, no readable text, no logos, 16:9",
        },
        {
            src: "/assets/img/blog/gbp-nap.webp",
            alt: "Nom, manzil va telefonning turli manbalarda mos kelishini tekshirish sxemasi",
            caption: "Nomuvofiqlik jimgina paydo bo'ladi va nufuz signalini ikkiga bo'ladi",
            prompt:
                "NAP consistency audit illustration: the same business name, address and phone shown across four cards (website footer, map profile, directory listing, social page) with two mismatches highlighted in amber; clean flat cards on light background, blurred placeholder text, no logos, 4:3",
        },
        {
            src: "/assets/img/blog/klinika-navbat.webp",
            alt: "Klinikada qabul va navbat tizimi — xaritadan kelgan mijoz oqimini qabul qilish",
            caption: "Xaritadan kelgan oqimni qabul qiladigan jarayon bo'lishi shart",
        },
    ],

    relatedServices: ["google-business", "seo", "korporativ-saytlar"],
    relatedPosts: ["ozbekistonda-ikki-tilli-seo", "ariza-tannarxi-seo-ads-instagram", "web-sayt"],
};

const ru = {
    meta: {
        title: "Настройка профиля Google Business: как вас найдут | Innobek",
        description:
            "Настройка профиля Google Business: категории, единство NAP, отзывы, фото и измерение результата. Как считать заявки с карт и сравнивать их с другими каналами.",
        keywords: [
            "настройка профиля Google Business",
            "добавить бизнес на Google Карты",
            "локальное SEO Ташкент",
            "как попасть в локальную выдачу",
            "работа с отзывами клиентов",
            "поиск рядом со мной",
        ],
    },
    h1: "Найдут ли вас, когда клиент ищет «рядом со мной»?",
    lead:
        "Для бизнеса с офлайн-точкой отдача от карты часто оказывается выше, чем от сайта. Сам профиль бесплатный — вся работа сводится к точности и регулярности. Разбираем, что настраивать, как измерять результат и когда этот канал вам не подходит.",
    category: "SEO и рост",
    readingTime: "9 минут",

    body: [
        {
            type: "p",
            text:
                "Для владельца магазина, клиники, сервиса или ресторана самый дешёвый поток клиентов приходит с карты. Но во многих компаниях профиль либо вообще не заведён, либо заполнен один раз и заброшен. В результате клиент уходит к конкуренту в двухстах метрах.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Как работает запрос «рядом со мной»?" },
        {
            type: "p",
            text:
                "Когда человек набирает в телефоне «стоматология рядом» или просто «шиномонтаж», Google сначала показывает блок карты — обычно три карточки компаний с рейтингом, часами работы и кнопкой маршрута. Обычная поисковая выдача идёт ниже этого блока.",
        },
        {
            type: "p",
            text:
                "В этот блок попадает не сайт, а профиль Google Business. Профиль — это карточка компании внутри Google: название, адрес, телефон, категория, часы работы, фотографии, отзывы и публикации. Он бесплатный, и управляете им вы.",
        },
        {
            type: "p",
            text:
                "Важный момент: интент таких запросов очень горячий. Человек не собирает информацию — он готов приехать сейчас. Поэтому стоимость заявки с карты обычно оказывается ниже, чем в остальных каналах.",
        },

        { type: "h2", text: "Что влияет на позицию в карте?" },
        {
            type: "p",
            text:
                "Локальная выдача строится на трёх группах сигналов. Знать их полезно: на две из них вы влияете полностью, на третью — почти никак.",
        },
        {
            type: "list",
            items: [
                "Релевантность — насколько профиль соответствует запросу. Инструменты здесь такие: точная основная категория, дополнительные категории и список услуг. Это полностью под вашим контролем.",
                "Расстояние — где физически находится пользователь. Изменить это нельзя, но корректно заданная зона обслуживания расширяет границы показа.",
                "Известность — как часто и насколько единообразно компания упоминается в сети: количество и качество отзывов, сигналы с сайта, записи в каталогах и справочниках. Самая медленная, но самая устойчивая часть.",
            ],
        },
        { type: "image", image: 1 },
        {
            type: "p",
            text:
                "На практике основной рост дают первая и третья группы. Профиль с неверной категорией не появится в выдаче по нужному запросу ни при каком количестве отзывов — Google просто считает его относящимся к другой теме.",
        },

        { type: "h2", text: "Семь самых частых ошибок в профиле" },
        {
            type: "p",
            text:
                "Откройте свой профиль и пройдите список построчно. В большинстве компаний находится минимум три пункта, и все они исправляются бесплатно.",
        },
        {
            type: "ol",
            items: [
                "Основная категория выбрана слишком широко. Вместо «Магазин» нужна точная формулировка вроде «Магазин автозапчастей» — с неё начинается релевантность.",
                "Список услуг пустой. Заведите каждую услугу отдельной строкой: клиент ищет именно этими словами.",
                "Часы работы устарели или не указаны праздничные дни. Клиент, приехавший к закрытой двери, оставит отзыв — и он будет негативным.",
                "Фотографий нет или стоит один логотип. Нужны фасад, интерьер, команда и процесс работы: клиент хочет узнать место ещё до входа.",
                "Телефон на сайте и в профиле не совпадает. Самое простое несоответствие и одно из самых вредных.",
                "Профиль ведётся на одном языке. На рынке Узбекистана описание и названия услуг логично дать на обоих языках — подробно об этом мы писали в материале про двуязычное SEO.",
                "Ссылка ведёт на главную страницу. Если профиль относится к конкретному филиалу, ссылка должна вести на страницу этого филиала с UTM-меткой.",
            ],
        },

        { type: "h2", text: "Что такое единство NAP и почему это важно?" },
        {
            type: "p",
            text:
                "NAP — это название (Name), адрес (Address) и телефон (Phone). Единство означает, что все три пункта написаны дословно одинаково на сайте, в профиле Google, в соцсетях и во внешних каталогах.",
        },
        {
            type: "p",
            text:
                "Расхождения возникают незаметно. Офис переехал — на сайте обновили, в профиле забыли. Подключили новый номер — в профиле поменяли, в каталоге остался старый. Для Google это может выглядеть как два разных бизнеса, и сигнал известности делится пополам.",
        },
        { type: "image", image: 2 },
        {
            type: "p",
            text:
                "Проверка несложная: вбейте в поиск название компании и номер телефона, выпишите все найденные записи. Затем сверьте каждую с одним эталонным вариантом. Это разовая работа, дальше список просто обновляется при каждом изменении.",
        },

        { type: "h2", text: "Как работать с отзывами?" },
        {
            type: "p",
            text:
                "Отзывы — самый сильный и при этом самый дешёвый инструмент локальной выдачи. Но покупать их нельзя: накрутка вычисляется, и профиль может попасть под ограничения. Правильный путь — выстроить регулярный естественный поток.",
        },
        {
            type: "list",
            items: [
                "Встройте просьбу об отзыве в процесс: после оказания услуги отправьте прямую ссылку в SMS или Telegram. Чем короче путь, тем выше конверсия.",
                "Отвечайте на каждый отзыв, включая положительные. Профиль без ответов выглядит заброшенным.",
                "На негатив отвечайте в течение суток, без спора и с публично описанным решением. Этот ответ пишется для следующего читателя, а не для автора.",
                "В ответе естественно упоминайте название услуги — это заодно работает на релевантность профиля.",
                "Распределяйте поток равномерно. Двадцать отзывов за неделю и полгода тишины выглядят неестественно.",
            ],
        },

        { type: "h2", text: "Как измерять результат?" },
        {
            type: "p",
            text:
                "Главная проблема канала карт в том, что его чаще всего вообще не измеряют. Фраза «кажется, людей стало больше» не может быть основанием для бюджетного решения. Достаточно четырёх цифр.",
        },
        {
            type: "ol",
            items: [
                "Показатели самого профиля: показы в поиске, переходы на сайт, звонки и запросы маршрута. Эти данные доступны бесплатно внутри профиля.",
                "Поставьте UTM-метку на ссылку сайта — тогда переходы с карты будут видны в аналитике отдельной строкой.",
                "Для звонков используйте отдельный номер или поле «источник» в CRM. Можно и проще: менеджер спрашивает, откуда о вас узнали.",
                "В конце месяца разделите расходы на количество заявок — получите стоимость заявки по каналу. Теперь её можно сравнить с Google Ads и SEO в одной таблице.",
            ],
        },
        {
            type: "p",
            text:
                "Формулу расчёта стоимости заявки по каналам мы разобрали в отдельной статье. Карта обычно показывает в этой таблице самую низкую цифру — но объём у неё ограничен, поскольку канал работает только на ближнюю аудиторию.",
        },

        { type: "h2", text: "Сколько это стоит и когда окупается?" },
        {
            type: "p",
            text:
                "Сам профиль в Google бесплатный. Вы платите только за работу: настройку, контент и регулярное ведение. Ниже цены Innobek и состав пакетов.",
        },
        {
            type: "table",
            head: ["Пакет", "Цена", "Что входит", "Кому подходит"],
            rows: [
                [
                    "Разовая настройка",
                    "2 500 000 сум",
                    "Создание или восстановление профиля, категории и услуги, проверка NAP, фото и описание",
                    "Одна точка, профиля нет или он заброшен",
                ],
                [
                    "Ежемесячное ведение",
                    "От 2 500 000 сум",
                    "Публикации, обновление фото, ответы на отзывы, отчёт по показателям",
                    "Точка, которой нужен постоянный поток",
                ],
                [
                    "Сеть филиалов",
                    "От 6 000 000 сум",
                    "До трёх филиалов, единый стандарт NAP, сводный отчёт",
                    "Компания с несколькими адресами",
                ],
                [
                    "Дополнительный филиал",
                    "1 500 000 сум в месяц",
                    "Профиль и ведение для каждого следующего адреса",
                    "Растущая сеть",
                ],
            ],
        },
        {
            type: "p",
            text:
                "Окупаемость считайте на своих цифрах. Допустим, после настройки профиль даёт 30 звонков и 40 запросов маршрута в месяц. Пятнадцать из них становятся реальными клиентами, средний чек 400 000 сум, маржа 40% — это 2 400 000 сум чистой прибыли в месяц.",
        },
        {
            type: "p",
            text:
                "В таком сценарии разовая настройка окупается уже в первый месяц, а ежемесячное ведение остаётся расходом, который удерживает рост. Если ваш средний чек 50 000 сум, расчёт будет совсем другим: вам нужен объём, а значит, и каналы помимо карты.",
        },
        { type: "image", image: 3 },

        { type: "h2", text: "Сколько стоит ничего не делать?" },
        {
            type: "p",
            text:
                "Компания без профиля теряет не только трафик, но и контроль. Google нередко создаёт карточку сам, на основе пользовательских данных: адрес может оказаться приблизительным, часы работы неверными, телефон устаревшим.",
        },
        {
            type: "p",
            text:
                "На негативный отзыв в такой карточке никто не отвечает. А клиент видит закрытую дверь и отзыв без ответа. То есть вы получаете ущерб от канала, которого у вас формально нет.",
        },
        {
            type: "callout",
            text:
                "Минимальный шаг: заявите права на профиль и приведите в порядок три вещи — категорию, часы работы и телефон. Это бесплатно, занимает около часа и часто даёт звонки сразу.",
        },

        { type: "h2", text: "Когда этот канал вам не подходит?" },
        {
            type: "p",
            text:
                "Google Business полезен не всем одинаково. В перечисленных ниже случаях бюджет лучше направить в другое место.",
        },
        {
            type: "list",
            items: [
                "Клиенты по всей стране, а география не имеет значения. Для онлайн-сервиса или доставки по всей республике карта почти не работает.",
                "Продажи идут через тендеры или длинные B2B-переговоры. Решение здесь не начинается с карты.",
                "У вас нет физического адреса и зона обслуживания тоже не определена. Такой профиль могут просто не подтвердить.",
                "Точка уже работает на пределе мощности. Если новый поток заявок обработать некому, сначала расширьте процесс.",
                "Некому заниматься отзывами. Негатив без ответов превращает профиль из плюса в минус.",
            ],
        },
        {
            type: "quote",
            text:
                "Карта — не бесплатный канал, а дешёвый. Основной расход здесь не деньги, а регулярность.",
        },
    ],

    faq: [
        {
            q: "Профиль Google Business действительно бесплатный?",
            a: "Да, за создание, заполнение и ведение профиля Google не берёт денег. Платить приходится только за работу: корректную структуру категорий и услуг, подготовку фотографий, написание публикаций и регулярную работу с отзывами. В Innobek разовая настройка стоит 2 500 000 сум, ежемесячное ведение начинается от 2 500 000 сум.",
        },
        {
            q: "Сколько занимает подтверждение профиля?",
            a: "Способ подтверждения зависит от типа бизнеса: это может быть видеоподтверждение, код по почте или звонок. На практике процесс растягивается от нескольких дней до нескольких недель, иногда требуется повторная попытка. Поэтому подтверждение стоит запускать заранее, до старта маркетинговой кампании, а не одновременно с ней.",
        },
        {
            q: "Можно ли гарантировать первое место в карте?",
            a: "Нет. Локальная выдача зависит ещё и от местоположения пользователя: один профиль на соседней улице может быть первым, а в двух километрах — третьим. Поэтому обещаниям гарантированного места верить не стоит. Измеримая цель другая: ежемесячный рост показов, звонков и запросов маршрута.",
        },
        {
            q: "Можно ли просто купить отзывы?",
            a: "Это самый дорогой из коротких путей. Накрученные отзывы вычисляются и удаляются, а профиль может попасть под ограничения вплоть до полного удаления. Безопаснее и эффективнее отправлять клиенту прямую ссылку сразу после оказания услуги. Регулярный поток настоящих отзывов работает стабильнее любого купленного рейтинга.",
        },
        {
            q: "Сколько профилей должно быть у одной компании?",
            a: "Правило простое: один профиль на один физический адрес. Если два профиля привязаны к одному адресу, они помечаются как дубликаты, и сигналы делятся. Для филиалов заводятся отдельные профили, но стандарт названия, телефона и категории должен быть единым. В Innobek пакет для сети начинается от 6 000 000 сум.",
        },
        {
            q: "Можно ли работать только с профилем, без сайта?",
            a: "На старте можно, и часто это разумное решение. Но профиль — арендованная площадка: правила меняются, карточку могут ограничить, а база клиентов вам не принадлежит. Сайт же усиливает сигналы известности и положительно влияет на позицию в самой карте. Самая устойчивая модель — оба инструмента вместе.",
        },
    ],

    cta: {
        h: "Бесплатно проверим ваш профиль",
        p:
            "Посмотрим категории, единство NAP, фотографии и состояние отзывов, затем скажем, какое исправление даст результат быстрее всего. Если карта не подходит вашей модели, скажем и об этом прямо.",
        button: "Проверить профиль",
    },

    images: [
        {
            src: "/assets/img/blog/gbp-yaqin-atrofda.webp",
            alt: "Результаты поиска на карте и кнопки маршрута на экране телефона",
            caption: "Так выглядит запрос «рядом со мной» — обычная выдача идёт ниже этого блока",
            prompt:
                "Phone held in hand showing a map search results list with three local business cards, star ratings and route buttons, blurred city street in the background; realistic mobile photography style, neutral generic map UI, no real brand marks, no readable text, 16:9",
        },
        {
            src: "/assets/img/blog/gbp-omillar.webp",
            alt: "Схема трёх факторов, влияющих на позицию в локальной выдаче",
            caption: "Два фактора из трёх полностью находятся под вашим контролем",
            prompt:
                "Local ranking factors diagram: three weighted pillars labelled by icon only — relevance (category and services), distance (service area pin), prominence (reviews, mentions, site signals) — feeding into a map pack result card; clean flat infographic, blue and green, no readable text, no logos, 16:9",
        },
        {
            src: "/assets/img/blog/gbp-nap.webp",
            alt: "Схема проверки совпадения названия, адреса и телефона в разных источниках",
            caption: "Расхождения появляются незаметно и делят сигнал известности пополам",
            prompt:
                "NAP consistency audit illustration: the same business name, address and phone shown across four cards (website footer, map profile, directory listing, social page) with two mismatches highlighted in amber; clean flat cards on light background, blurred placeholder text, no logos, 4:3",
        },
        {
            src: "/assets/img/blog/klinika-navbat.webp",
            alt: "Система записи и очереди в клинике — приём потока клиентов с карты",
            caption: "Поток с карты должен быть кому и чем обрабатывать",
        },
    ],

    relatedServices: ["google-business", "seo", "korporativ-saytlar"],
    relatedPosts: ["ozbekistonda-ikki-tilli-seo", "ariza-tannarxi-seo-ads-instagram", "web-sayt"],
};

const content = { uz, ru };

export default content;
